import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {get, isArray, map} from 'lodash';

// Components
import Select from 'react-select';

// Containers
import withFormField from '../../containers/with-form-field';

// Styles
import './multi-select.scss';

function MultiSelect({
    className,
    disabled,
    multi = true,
    name,
    onBlur,
    onChange,
    options,
    placeholder,
    updateOptions: updateOptionsProp,
    value,
}) {
    const getClass = () => classnames('Select multi-select--select', className);

    const handleBlur = (event) => {
        if (onBlur) {
            onBlur(event);
        }
    };

    const handleChange = (value) => {
        onChange(null, isArray(value) ? map(value, 'value') : get(value, 'value'));
    };

  const updateOptions = (options, values) => {
      return options.filter(option => !values.includes(option.value));
  };

  const defaultValues = (options, values) => {
    return options.filter(option => values.includes(option.value));
  };

  return (
        <div className="multi-select">
            <Select
                isMulti={multi}
                disabled={disabled}
                name={name}
                options={updateOptionsProp && isArray(value) ? updateOptions(options, value) : options}
                placeholder={placeholder}
                value={multi ? (isArray(value) ? defaultValues(options, value) : []) : (options.find(o => o.value === value) || null)}
                onBlur={handleBlur}
                onChange={handleChange}
                className={getClass()}
                classNamePrefix="Select"
            />
        </div>
    );
}

MultiSelect.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    multi: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string,
    updateOptions: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number, PropTypes.array]).isRequired,
};

export default withFormField(MultiSelect);
